import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChartData } from './user-dashboard.service';

const LOCAL_STORAGE_KEY = 'largeChartViewData';

@Injectable({
  providedIn: 'root'
})
export class LargeChartViewService {
  private chartDataSubject = new BehaviorSubject<ChartData | null>(null);
  public chartData$: Observable<ChartData | null> = this.chartDataSubject.asObservable();

  setChartData(chartData: ChartData): void {
    this.chartDataSubject.next(chartData);
    // Also store in sessionStorage for persistence
    try {
      sessionStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(chartData));
    } catch (error) {
      console.error('Error saving chart data to sessionStorage:', error);
    }
  }

  getChartData(): ChartData | null {
    // First try to get from BehaviorSubject
    const serviceData = this.chartDataSubject.value;
    if (serviceData) {
      return serviceData;
    }

    // If not in service, try to get from sessionStorage
    try {
      const storedData = sessionStorage.getItem(LOCAL_STORAGE_KEY);
      if (storedData) {
        const chartData = JSON.parse(storedData) as ChartData;
        // Update BehaviorSubject with retrieved data
        this.chartDataSubject.next(chartData);
        return chartData;
      }
    } catch (error) {
      console.error('Error retrieving chart data from sessionStorage:', error);
    }

    return null;
  }

  clearChartData(): void {
    this.chartDataSubject.next(null);
    // Also clear from sessionStorage
    try {
      sessionStorage.removeItem(LOCAL_STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing chart data from sessionStorage:', error);
    }
  }
}

